import React from "react";

import cx from "classnames";
import styles from "./styles.module.scss";
interface SwitchButtonProps {
    className?: string;
    label?: string;
    checked: boolean;
    id: string;
    // eslint-disable-next-line no-unused-vars
    handleCheck: () => void;
    disabled?: boolean;
  }
  
   const SwitchButton: React.FC<SwitchButtonProps> = ({
    className,
    checked,
    label,
    handleCheck,
    id,
    disabled
  }) => {
    return (
      <div className={cx(styles.switchInputContainer, className)}>
        {label && <span className={styles.label}>{label}</span>}
        <div className={cx(styles.switchContainer)} onClick={() => {
          if(!disabled){
            handleCheck()
          }
          }}>
          <input
            type="checkbox"
            id={id}
            checked={checked}
            className={styles.toggleInput}
          />
          <span className={cx(styles.toggleLabel, {
            [styles.disabled]: disabled, 
            })}/>
        </div>
      </div>
    );
  };

export default SwitchButton;